//region :: Imports ::
import {ICustomProperties} from '@microsoft/applicationinsights-web';
import ILogger from './ILogger';

//endregion

/** */
class ConsoleLogger implements ILogger {

    /** */
    public trackInfo(message: string, properties?: ICustomProperties): void {
        console.info(message, properties);
    }

    /** */
    public trackWarning(message: string, properties?: ICustomProperties): void {
        console.warn(message, properties);
    }

    /** */
    public trackError(error: Error, properties?: ICustomProperties): void {

        //  Don't bother writing to the console as the browser
        //  will do that for us. Calling the following method
        //  just clutters the console window.
        //
        //  console.error(error, properties);

    }

}

export default ConsoleLogger;
